import SettingService from '@/services/settingservice'
import store from '@/store'

export default {
  formatMoney (amount, decimalCount = 0, decimal = '.', thousands = ',') {
    try {
      decimalCount = Math.abs(decimalCount)
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount
      const negativeSign = amount < 0 ? '-' : ''
      let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString()
      let j = (i.length > 3) ? i.length % 3 : 0
      return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : '')
    } catch (e) {
      console.log(e)
    }
  },
  transformNull (data, reverse = false) {
    const newObj = {}
    if (reverse) {
      Object.keys(data).forEach((key, index) => {
        if (data[key] === null) {
          newObj[key] = ''
        } else {
          newObj[key] = data[key]
        }
      })
    } else {
      Object.keys(data).forEach((key, index) => {
        if (data[key] === '') {
          newObj[key] = null
        } else {
          newObj[key] = data[key]
        }
      })
    }
    return newObj
  },
  isEmptyObj (obj) {
    return Object.keys(obj).length === 0
  },
  async getSellerInfo () {
    await SettingService.getSellerInformation()
      .then(response => {
        store.commit('setUser', response.seller)
      })
  },
  chunkArray (myArray, chunkSize) {
    let results = []
    while (myArray.length) {
      results.push(myArray.splice(0, chunkSize))
    }
    return results
  },
  delay (time) {
    return new Promise(resolve => setTimeout(resolve, time))
  }
}

export function replaceHTMLSellerInfo (html) {
  if (!html) {
    return ''
  }
  const sellerId = store.getters.getUser.sellerId
  const sellerName = store.getters.getUser.sellerName
  const companyName = store.getters.getUser.companyName
  const chatWorkRoomId = store.getters.getUser.chatWorkRoomId || ''
  const noticeEmail = store.getters.getUser.noticeEmail || ''

  return html
    .replace(/{{sellerid}}/g, sellerId)
    .replace(/{{sellername}}/g, sellerName)
    .replace(/{{companyname}}/g, companyName)
    .replace(/{{chatworkroomid}}/g, chatWorkRoomId)
    .replace(/{{noticeemail}}/g, noticeEmail)
}

// Detect timestamps like: 00:10, 01:02:30, [00:10], [01:02:30]
const TIMESTAMP_REGEX = /\[?(\d{1,2}:)?\d{1,2}:\d{2}\]?/g

export function validateTimestamp (time) {
  const parts = time.split(':').map(Number)

  if (parts.some(isNaN)) return false

  if (parts.length === 2) {
    // eslint-disable-next-line no-unused-vars
    const [m, s] = parts
    return s >= 0 && s < 60
  }

  if (parts.length === 3) {
    // eslint-disable-next-line no-unused-vars
    const [h, m, s] = parts
    return m >= 0 && m < 60 && s >= 0 && s < 60
  }

  return false
}

export function convertTimestampsToLinks (html) {
  return html.replace(TIMESTAMP_REGEX, (match) => {
    const clean = match.replace(/\[|\]/g, '')
    if (!validateTimestamp(clean)) return match

    const seconds = timeStringToSeconds(clean)
    return `<a href="javascript:void(0)" class="timestamp-link" data-seek="${seconds}">${clean}</a>`
  })
}

export function timeStringToSeconds (time) {
  const parts = time.split(':').map(Number)
  if (parts.length === 3) return parts[0] * 3600 + parts[1] * 60 + parts[2]
  if (parts.length === 2) return parts[0] * 60 + parts[1]
  return 0
}



// WEBPACK FOOTER //
// ./src/common/utility.js